import React from 'react'
import moment from 'moment'
import AssetThumbnail from './AssetThumbnail'

const AssetList = ({
  state,
  dispatch,
  sectionRef,
  onScrollUp,
  onScrollDown,
  onBackToTop,
  onLoadMore,
  loadedImages,
  setLoadedImages
}) => {
  // Determine the title based on the selected category
  const getTitle = () => {
    if (state.selectedCategories.length === 2) {
      return `${state.selectedCategories[0].name} - ${state.selectedCategories[1].name}`
    } else if (
      state.selectedCategories.length === 1 &&
      state.selectedCategories[0].type === 'year'
    ) {
      return `Year - ${state.selectedCategories[0].name}`
    } else {
      return ''
    }
  }

  const getSortedAssets = () => {
    const assetsObject = state.publishedAssets
    if (!assetsObject || typeof assetsObject !== 'object') {
      return []
    }

    // Sort assets by the most current date - matching production implementation
    const sortedAssetIds = Object.keys(assetsObject).sort((a, b) => {
      const dateA = moment(
        assetsObject[a].metadata?.content?.date || assetsObject[a].createdAt
      )
      const dateB = moment(
        assetsObject[b].metadata?.content?.date || assetsObject[b].createdAt
      )

      return dateA.diff(dateB)
    })

    // Return the sorted assets as objects
    return sortedAssetIds.map(assetId => ({
      ...assetsObject[assetId],
      id: assetId
    }))
  }

  // Responsive screen detection
  const isLargeScreen = window.innerWidth >= 3840 && window.innerHeight >= 2160
  const isSmallScreen = window.innerWidth < 450

  const handleDownArrowClick = e => {
    onScrollDown()
    if (onLoadMore) {
      onLoadMore(e)
    }
  }

  const sortedAssets = getSortedAssets()

  return (
    <section className="main-level03" ref={sectionRef} tabIndex="0">
      <div className="below-level03">
        {getTitle() && <h2 className="row-title2">{getTitle()}</h2>}
        <div className="cat-container-level02">
          <div className="gallery-thumb-container-l3">
            {sortedAssets.map((asset, idx) => {
              return (
                <AssetThumbnail
                  key={`asset-${asset.id}`}
                  asset={asset}
                  assetId={asset.id}
                  idx={idx}
                  state={state}
                  dispatch={dispatch}
                  isLargeScreen={isLargeScreen}
                  isSmallScreen={isSmallScreen}
                  loadedImages={loadedImages}
                  setLoadedImages={setLoadedImages}
                />
              )
            })}
          </div>
        </div>
      </div>
      <div>
        <div onClick={onScrollUp} className="up_arrow_invisible_assets"></div>
        <div
          onClick={handleDownArrowClick}
          className="down_arrow_invisible_assets"
        ></div>
        <div onClick={onBackToTop} className="top_arrow_invisible_assets"></div>
      </div>
    </section>
  )
}

export default AssetList
